/* eslint-disable semi */

import { Ajax, AjaxError, ISupportSpinner } from '../shared/Ajax';

import { AbnDetails } from '../models/AbnDetails'


export class AbnController extends Ajax {
  constructor() {
    super(window.__emdgBaseUrl, '/api/abn');
  }

  getByAbn(owner: ISupportSpinner, abn: string, success: { (res: AbnDetails): any }, error?: AjaxError) {
    // const user: User = { id: 1, name: 'Alice' };
    // const product: Product = { id: 42, name: 'Widget', price: 19.99 };

    super._call('get', '', owner, { abn }, null, success, error)
  }

  isApplicationExistsForAbn(owner: ISupportSpinner, abn: string, financialYear: string, success: { (res: boolean): any }, error?: AjaxError) {
    super._call('get', 'IsApplicationExistsForAbn', owner, { abn: abn, financialYear: financialYear }, null, success, error)
  }

  anySubmittedApplicationExistsForAbn(owner: ISupportSpinner, abn: string, financialYear: string, success: { (res: boolean): any }, error?: AjaxError) {
    super._call('get', 'AnySubmittedApplicationExistsAsync', owner, { abn: abn, financialYearName: financialYear }, null, success, error)
  }

}
